import { render, staticRenderFns } from "./uploadMusicRecord.vue?vue&type=template&id=6835b239&scoped=true&"
import script from "./uploadMusicRecord.vue?vue&type=script&lang=js&"
export * from "./uploadMusicRecord.vue?vue&type=script&lang=js&"
import style0 from "./uploadMusicRecord.vue?vue&type=style&index=0&id=6835b239&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6835b239",
  null
  
)

export default component.exports